import {Component, EventEmitter, Injector, Output} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {ModalBaseComponent} from '../modal-base-component';

@Component({
  selector: 'app-delete-question-modal',
  templateUrl: './delete-question-modal.component.html',
  styleUrls: ['./delete-question-modal.component.css']
})
export class DeleteQuestionModalComponent extends ModalBaseComponent {

  public ids: Array<number>;
  public type: string;

  @Output() action = new EventEmitter();

  constructor(private inject: Injector, private _bsModalRef: BsModalRef) {
    super(inject);
  }

  // call this whenever you want to close modal
  public closeModal(): void {
    this._bsModalRef.hide();
  }

  public delete() {
    this.action.emit(true);
    this.closeModal();
  }

}



// WEBPACK FOOTER //
// ./src/app/achelos-iot/modals/delete-question-modal/delete-question-modal.component.ts